// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__XpKDO","icon":"EmptyState_icon__CfxoA","title":"EmptyState_title__V7tXM","desc":"EmptyState_desc__kEULY"};